export default {
  methods: {
    async handleCopy(merchantCode) {
      try {
        await navigator.clipboard.writeText(merchantCode)

        this.onCopySuccess(merchantCode)
      } catch (e) {
        this.onCopyError()
      }
    },
    onCopySuccess(str) {
      this.$message({
        type: 'success',
        message: `Copied ${str} to clipboard`,
      })
    },
    onCopyError() {
      this.$message({
        type: 'error',
        message: this.$t('general_copied_text3'),
      })
    },
  },
}
